import type { NavigateOptions } from 'react-router';

import { useParams, useSearchParams } from 'react-router';

export function useQuizParams() {
  const { id, attemptId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const n: string | undefined = searchParams.get('n') ?? undefined;
  const parsedN: number = n ? parseInt(n, 10) : 0;
  const sectionNumber: number = isNaN(parsedN) ? 0 : parsedN;

  const setSectionNumber = (number: number, options?: NavigateOptions): void => {
    setSearchParams((searchParams) => {
      searchParams.set('n', String(number));
      return searchParams;
    }, options);
  };

  return {
    id: id ?? '',
    attemptId: attemptId ?? '',
    sectionNumber,
    setSectionNumber,
  };
}
